export enum IMetal {
  gold18k = '18 karat gold',
  gold24k = '24 karat gold',
  gold14k = '14 karat gold',
}
